import React, { useEffect, useState } from "react";
import {
  doc,
  getDocs,
  getFirestore,
  collection,
  deleteDoc,
} from "firebase/firestore";
import { app } from "../firbase/confing";
import { authUser } from "./Login";
import Upload from "./Upload";
import "./login.css";

const db = getFirestore(app);

async function getDoc() {
  const querySnapshot = await getDocs(
    collection(db, authUser?.currentUser?.uid)
  );
  let data = [];
  querySnapshot.forEach((doc) => {
    data.push(doc.data());
  });
  return data.sort((a, b) => a.sort - b.sort).reverse();
}
export default function Videos() {
  const [data, setData] = useState(null);
  const [updateDoc, setupdateDoc] = useState(false);
  const [updateDocDetails, setupdateDocDetails] = useState(false);
  const [skeleton, setSkeleton] = useState(true);
  useEffect(() => {
    let mount = true;
    if (mount) {
      try {
        getDoc().then((a) => {
          setData(a);
          setSkeleton(false);
        });
      } catch (error) {
        console.log("something went wrong");
      }
    }
    return () => {
      mount = false;
    };
  }, [updateDoc]);

  const EDIT_DOC = async (data) => {
    setupdateDocDetails(data);
    setupdateDoc(true);
  };
  const Delete = async (id) => {
    await deleteDoc(doc(db, authUser?.currentUser?.uid, id));
  };
  const changeDiv = () => {
    setupdateDoc(false);
  };
  const DELETE_DOC = (id, e) => {
    let a = e.target.parentElement.parentElement.parentElement;
    let b = a.querySelector(".loading-for-delete-doc-none");
    b.className = "loading-for-delete-doc";
    Delete(id).then(() => {
      e.target.parentElement.parentElement.parentElement.remove();
    });
  };
  return (
    <>
      {skeleton ? (
        <div className="container d-flex justify-content-center">
          <div className="loading-for-delete-doc">
            <span
              className="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {"  "}
            <span
              className="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {"  "}
            <span
              className="spinner-grow spinner-grow-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </div>
      ) : (
        <div className="container mt-4 mb-4">
          {updateDoc ? (
            <Upload detail={updateDocDetails} changeDiv={changeDiv} />
          ) : (
            data?.map((doc) => (
              <div
                key={doc.id}
                className="row mt-5 position-relative overflow-hidden border-for-video"
              >
                <div className="loading-for-delete-doc-none">
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {"  "}
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {"  "}
                  <span
                    className="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
                <div className="col-lg-6 col-md-10  p-2">
                  <div className="parentIframe">
                    <iframe
                      src={doc.url}
                      className="iframe"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
                <div className="col-lg-6 col-md-10 p-3 video-text-show">
                  <p className="mb-2">Movie : {doc.description}</p>
                  <p className="mb-2">Directors : {doc.directors}</p>
                  <p className="mb-2">Actors : {doc.actors}</p>
                  <p className="mb-2">Type : {doc.type}</p>
                  <p className="mb-2">Created Date : {doc.date}</p>
                  <p className="mb-3">Created Time : {doc.time}</p>
                  <div className="edit-delete ">
                    <button
                      onClick={() => {
                        EDIT_DOC(doc);
                      }}
                    >
                      EDIT
                    </button>
                    <button
                      onClick={(e) => {
                        DELETE_DOC(doc.id, e);
                      }}
                    >
                      DELETE
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
}
